"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Piece;
(function (Piece) {
    Piece["Pawn"] = "pawn";
    Piece["Knight"] = "knight";
    Piece["Bishop"] = "bishop";
    Piece["Rook"] = "rook";
    Piece["Queen"] = "queen";
    Piece["King"] = "king";
})(Piece = exports.Piece || (exports.Piece = {}));
var FenPiece;
(function (FenPiece) {
    FenPiece["p"] = "p";
    FenPiece["n"] = "n";
    FenPiece["b"] = "b";
    FenPiece["r"] = "r";
    FenPiece["q"] = "q";
    FenPiece["k"] = "k";
    FenPiece["P"] = "P";
    FenPiece["N"] = "N";
    FenPiece["B"] = "B";
    FenPiece["R"] = "R";
    FenPiece["Q"] = "Q";
    FenPiece["K"] = "K";
})(FenPiece = exports.FenPiece || (exports.FenPiece = {}));
var BoardContent;
(function (BoardContent) {
    BoardContent["WhitePawn"] = "white pawn";
    BoardContent["WhiteKnight"] = "white knight";
    BoardContent["WhiteBishop"] = "white bishop";
    BoardContent["WhiteRook"] = "white rook";
    BoardContent["WhiteQueen"] = "white queen";
    BoardContent["WhiteKing"] = "white king";
    BoardContent["BlackPawn"] = "black pawn";
    BoardContent["BlackKnight"] = "black knight";
    BoardContent["BlackBishop"] = "black bishop";
    BoardContent["BlackRook"] = "black rook";
    BoardContent["BlackQueen"] = "black queen";
    BoardContent["BlackKing"] = "black king";
    BoardContent["EmptySquare"] = "empty";
})(BoardContent = exports.BoardContent || (exports.BoardContent = {}));
